import {Component, inject} from '@angular/core';
import {AuthenticationService} from '@core/auth/authentication.service';
import {Router, RouterLink} from '@angular/router';
import {LoginService} from './login.service';
import {InputFieldComponent} from '../../../shared/components/form/input/input-field.component';
import {ButtonComponent} from '../../../shared/components/ui/button/button.component';
import {LabelComponent} from '../../../shared/components/form/label/label.component';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {SnackbarService} from '@shared/services/snackbar.service';

@Component({
  selector: 'app-login',
  imports: [
    ButtonComponent,
    LabelComponent,
    InputFieldComponent,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login {
  showPassword = false;
  isLoading = false;
  saveForm!: FormGroup;

  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);
  private service = inject(LoginService);
  private fB = inject(FormBuilder);
  private snackbarService = inject(SnackbarService);

  constructor() {
    this.verifyUserIsLoggedIn();
    this.makeForm();
  }

  private makeForm() {
    this.saveForm = this.fB.group({
      email: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  private verifyUserIsLoggedIn() {
    if (this.authenticationService.isAuthenticated())
      this.navigateToHome()
  }

  signIn() {
    this.isLoading = true;
    this.service.login(this.saveForm.value).subscribe({
      next: response => {
        if (response.data?.token) {
          this.authenticationService.saveSession(response);
          this.navigateToHome();
        }
      },
      error: (err) => {
        this.snackbarService.showSnackBar(err.error?.message || 'Error en el login', 'error');
      }
    }).add(() => {
      this.isLoading = false;
    });
  }

  private navigateToHome() {
    this.router.navigate([''], {replaceUrl: true});
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
